import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/${dossierId}/OtherDataComponentHistorical`, method: 'GET', token: token })
}
